import React from 'react';
import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import LogTrack from './Pages/LogTrack';
import Setting from './Pages/Setting';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LogTrack />} />
        <Route path="/Setting" element={<Setting />} />
        <Route path="/LogTrack" element={<LogTrack />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
